/**
 * Brand identity — deliberately NOT run through i18n.
 *
 * The logo lockup is a trademark, not copy: "Quran Fluency" and the
 * "a hikmahverses product" line must read identically in every locale,
 * including RTL. These used to be the `brand.name` / `app.tagline` keys,
 * which meant the machine-translation pass (and the DB override layer that
 * serves the unbundled launch languages) rewrote the logo text per language.
 * Keeping them as constants makes that structurally impossible.
 */
export const BRAND_NAME = "Quran Fluency";
export const BRAND_TAGLINE = "a hikmahverses product";

/**
 * Official WhatsApp community channel — a fixed public link, not a secret
 * and not admin-editable (unlike the Live Zoom Class settings, which live in
 * app_config and go through Admin > Modules > App Configuration). Kept here,
 * as the single source of truth, so the URL is never duplicated across the
 * dashboard's "Community & Live Learning" card and any future consumer.
 */
export const WHATSAPP_CHANNEL_URL = "https://whatsapp.com/channel/0029VbDZSFl9Bb664S3Fv20X";

/**
 * WhatsApp Business number that the Wati support bot is attached to —
 * digits only, country code first, no "+", no spaces (wa.me's required
 * format). NOT the same number/link as the Channel above: a Channel is
 * one-way broadcast and can never trigger a bot reply, only a real chat
 * with this Business number can.
 */
export const WHATSAPP_SUPPORT_NUMBER = "15558592435";

/** Click-to-chat link that pre-fills the message box (the user still has to
 * press send themselves — WhatsApp/Meta never allows a link to auto-send).
 * Wati's Keyword Action for this flow is set to trigger on "qfc support" —
 * defaultText must keep matching that exactly for the bot to fire. */
export function whatsappSupportUrl(defaultText = "qfc support") {
  return `https://wa.me/${WHATSAPP_SUPPORT_NUMBER}?text=${encodeURIComponent(defaultText)}`;
}
